import { get, post } from '@/axios/method';


// 通过code获取用户信息
export const getUserInfoByCode = (data) => get('/api/dm/market/wechat/oauth2/userinfo', { data });

// 通过unionId通、地理位置获取导购信息获取导购信息
export const getGuideInfoByUnionId = (data) => post('/api/dm/clue/dynamic/recommendGuide', data);

